module.exports = __webpack_public_path__ + "b50d333357bd5d407f32f69db7e5ae7b.pdf";